import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <p className="text-xs uppercase tracking-wider text-gray-600 mb-4 font-semibold">
              ABOUT US
            </p>
            <h1 className="text-5xl md:text-6xl font-bold text-navy mb-6">
              Funding Strategists, Not Lenders
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We prepare, position, and package you to qualify for real approvals from the institutions that matter
            </p>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-navy mb-6">
                Who We Are
              </h2>
              
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We are a funding strategy and business credit consulting firm that specializes in preparing businesses and individuals to qualify for funding. Unlike lenders who sell their own products, or brokers who simply submit applications hoping for the best, we take a strategic, underwriter-level approach to fundability.
              </p>

              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Our team understands what lenders actually look for when evaluating applications. We see the red flags, the missing pieces, and the opportunities that others miss. We fix these issues before you ever apply, positioning you for maximum approval rates and optimal funding terms.
              </p>

              <h2 className="text-3xl font-bold text-navy mb-6 mt-12">
                What Makes Us Different
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-10">
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-semibold text-navy mb-3">
                    We're Not a Lender
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    We don't have our own loan products to push. Our only goal is to position you for success with the best funding sources for your situation.
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-semibold text-navy mb-3">
                    Underwriter Perspective
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    We think like underwriters because we understand their criteria. We see what they see and fix issues before they become problems.
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-semibold text-navy mb-3">
                    Fundability First
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    We don't just submit applications. We build fundable profiles through proper structure, compliance, and strategic positioning.
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-xl font-semibold text-navy mb-3">
                    Long-Term Strategy
                  </h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    We're not interested in quick fixes or one-time deals. We build sustainable funding capacity that grows with your business.
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-navy mb-6 mt-12">
                Our Approach
              </h2>

              <p className="text-base text-gray-700 leading-relaxed mb-6">
                <strong className="text-navy">Compliance-First:</strong> Everything we do is above board, documented, and built to last. We don't use shortcuts, gray-area tactics, or anything that could jeopardize your long-term fundability.
              </p>

              <p className="text-base text-gray-700 leading-relaxed mb-6">
                <strong className="text-navy">Strategic Positioning:</strong> We prepare your business structure, credit profile, and documentation before you apply. This isn't about gaming the system — it's about presenting your true strengths in the way lenders need to see them.
              </p>

              <p className="text-base text-gray-700 leading-relaxed mb-6">
                <strong className="text-navy">Expert Execution:</strong> Timing matters. Sequencing matters. Which lenders you approach and when you approach them matters. We handle the strategy so you can focus on running your business.
              </p>

              <h2 className="text-3xl font-bold text-navy mb-6 mt-12">
                Who We Serve
              </h2>

              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We work with serious business owners and individuals who are committed to doing things the right way. Our clients value compliance, long-term strategy, and professional guidance over quick fixes and empty promises.
              </p>

              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Whether you're building business credit from scratch, optimizing your personal credit profile for funding, or positioning an established business for major capital raises, we provide the strategic guidance and expert execution you need to succeed.
              </p>

              <div className="bg-navy text-white p-8 rounded-xl mt-12">
                <h3 className="text-2xl font-bold mb-4">
                  Our Commitment
                </h3>
                <p className="text-base leading-relaxed">
                  We don't guarantee approvals — no one can. But we do guarantee that we'll prepare you properly, position you strategically, and execute with precision. We'll tell you the truth about what's possible, what needs work, and what timeline is realistic. No hype. No games. Just professional funding strategy that delivers results.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 bg-gray-50">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-navy mb-6">
              Ready to Work Together?
            </h2>
            <p className="text-lg text-gray-600 mb-10">
              Let's assess your funding needs and create a strategic plan
            </p>
            <Link
              to="/apply"
              className="inline-flex items-center bg-navy text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-navy-light transition-colors whitespace-nowrap cursor-pointer"
            >
              Start Your Application
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
